export default __webpack_public_path__ + "static/media/agents.1350997c.jpg";